/**
* Created For: 公用搜索条
* this.$emit("input",val)  this.$emit("enter",this.keyword)  this.$emit("blur",this.keyword)
* Author: xuRui.
* Date: 2019/12/30  15:30.
*/
<template>
  <div class="feedbackBox">
    <v-title title="药店属性变更" :isShowBack="true" :isDefaultBack="false" @backHandle="goBack();"></v-title>
    <div class="closeBox">
      <cube-form :model="model" @validate="validateHandler" @submit="submitHandler">
        <cube-form-group>
          <ul class="formBox">
            <li>
              <div class="title">
                <img :src="require('@/assets/feedback/name.png') " alt="">
                <p class="title-p">药店名称</p>
              </div>
              <div>
                <div>
                  <cube-form-item :field="fields[0]"></cube-form-item>
                </div>

              </div>

            </li>
            <li>
              <div class="title">
                <img :src="require('@/assets/feedback/property-black.png') " alt="">
                <p class="title-p">终端属性</p>
              </div>
              <div class="clientBox">
                <button v-for="(clientType,index) in clientTypes" type="button" :class="[curParams.clientType.includes(clientType.code) ? 'selected':'']" @click="typeClickHandle(clientType.code)" :key="index">{{ clientType.name }}</button>
              </div>
            </li>
            <li v-if="curParams.clientType[0] === '10102' ">
              <div class="title">
                <img :src="require('@/assets/feedback/headquarters.png') " alt="">
                <p class="title-p">总部名称</p>
              </div>
              <div>
                <cube-form-item :field="fields[1]"></cube-form-item>
              </div>
            </li>
            <li v-if="curParams.clientType[0] === '-1'">
              <div class="title">
                <img :src="require('@/assets/feedback/type.png') " alt="">
                <p class="title-p">终端类型</p>
              </div>
              <div>
                <cube-form-item :field="fields[2]"></cube-form-item>
              </div>
            </li>
            <li>
              <div class="title">
                <img :src="require('@/assets/feedback/photo.png') " alt="">
                <p class="title-p">现场照片</p>
              </div>
              <div>
                <div style="padding-left:40px">
                  <cube-upload
                    ref="upload"
                    v-model="files"
                    :max="3"
                    :process-file="processFile"
                  >
                  </cube-upload>
                </div>
                <!-- <cube-form-item :field="fields[4]"></cube-form-item> -->
                <span class="imgShow">
                  请提供药店门脸照片，以及营业执照照片，确保门脸牌匾和营业执照字体清晰可见。
                </span>
              </div>
            </li>
          </ul>
          <cube-form-group>
            <cube-button type="submit" :disabled="addsubmit">提交</cube-button>
          </cube-form-group>
        </cube-form-group>
      </cube-form>
    </div>
  </div>
</template>

<script>
import { getClientType } from '@/api/clientSearch'
import { addFeedBack } from '@/api/feedBack'
import compress from '@/utils/compress' // compress方法用的是鹅厂的，compress.js的完整代码在本文
export default {
  name: 'ChangeQuality',
  components: {},
  data () {
    const self = this
    return {
      addsubmit: false,
      imgList: [],
      imgObject: [],
      keyword: '',
      files: [],
      clientTypes: [],
      value: '',
      curParams: { clientType: [] },
      detailData: {},
      valid: undefined,
      validity: {},
      photoes: [],
      model: {
        address: '', // 地址
        clientId: '', // 终端ID
        clientType: '', // 终端类型
        clientTypeName: '', // 终端类型mingzi
        description: '', // 问题描述
        latitude: '', // 纬度
        longitude: '', // 经度
        parentName: '', // 总部名称
        name: '', // 终端名
        phone: '', // 电话
        photoes: [], // 照片
        type: 3, // 类型
        uploadValue: []
      },
      options: {
        scrollToInvalidField: true,
        layout: 'standard' // classic fresh
      },
      fields: [
        {
          type: 'input',
          modelKey: 'name',
          props: {
            placeholder: '',
            disabled: true,
            maxlength: 50
          },
          rules: {
            required: true
          },
          // validating when blur
          trigger: 'blur'
        },
        {
          type: 'input',
          modelKey: 'parentName',
          props: {
            maxlength: 50,
            placeholder: ''
          },
          rules: {
          },
          // validating when blur
          trigger: 'blur'
        },
        {
          type: 'input',
          modelKey: 'clientTypeName',
          props: {
            maxlength: 50,
            placeholder: ''
          },
          rules: {
          },
          // validating when blur
          trigger: 'blur'
        },
        {
          type: 'radio',
          modelKey: 'radioValue',
          label: '',
          options: [
            {
              label: 'Option1',
              value: 1
            },
            {
              label: 'Option2',
              value: 2
            },
            {
              label: 'Option3',
              value: 3,
              disabled: true
            }
          ],
          rules: {
          }

        },
        {
          type: 'upload',
          modelKey: 'uploadValue',
          simultaneousUploads: 3,
          props: {
            //  action: {
            //     target: 'https://upload.oonnnoo.com/upload',
            //     // fileName: 'upfile',
            //     // data: {
            //     //     token: 'token'
            //     // },
            //     checkSuccess: (res, file) => {
            //         console.log('res', file)
            //         let url = file.url
            //         self.imgObject.push({url:url,base:JSON.parse(JSON.stringify(self.imgList))[JSON.parse(JSON.stringify(self.imgList)).length-1]})
            //          self.$createToast({
            //             type: 'success',
            //             time: 1000,
            //             txt: '上传成功'
            //         }).show()
            //         return true
            //     }
            // },
            max: 3
          },
          events: {
            'files-added': (...args) => {
              self.toast = this.$createToast({
                txt: '正在上传。。。',
                time: 0,
                mask: false
              })
              self.toast.show()
              self.filesAdded(...args)
            },
            'file-removed': (...args) => {
              self.imgObject.forEach((item, index) => {
                if (item.url === args[0].url) {
                  self.imgObject.splice(index, 1)
                }
              })
            },
            'file-submitted': (...args) => {
              const url = args[0].url
              setTimeout(function () {
                self.toast.hide()
                self.imgObject.push({ url: url, base: JSON.parse(JSON.stringify(self.imgList))[JSON.parse(JSON.stringify(self.imgList)).length - 1] })
                console.log(self.imgObject)
                self.$createToast({
                  type: 'success',
                  time: 800,
                  txt: '上传成功'
                }).show()
              }, 800)
            }
          },
          rules: {
            // uploaded: (val, config) => {
            //     return Promise.all(val.map((file, i) => {
            //     return new Promise((resolve, reject) => {
            //         if (file.uploadedUrl) {
            //         return resolve()
            //         }
            //         // fake request
            //         setTimeout(() => {
            //             if (i % 2) {
            //                 reject(new Error())
            //             } else {
            //                 file.uploadedUrl = 'uploaded/url'
            //                 resolve()
            //             }
            //         }, 1000)
            //     })
            //     })).then(() => {
            //         return true
            //     })
            // }
          },
          messages: {
            uploaded: '上传失败'
          }
        }

      ]
    }
  },
  computed: {},
  created () {
    this.detailData = JSON.parse(this.$route.query.data)
    console.log('.....传来的值.......')
    this.model.name = this.detailData.clientName
    this.model.clientType = this.detailData.thirdType
    this.model.clientId = this.detailData.matchClientId
    this.clientTypeList()
  },
  methods: {
    clientTypeList () {
      const { entries } = Object
      const list = {}
      const listArr = []
      getClientType().then(
        (res) => {
          if (res.code === 1) {
            //  state.clientType = res.data;
            // eslint-disable-next-line no-unused-vars
            for (const [key, value] of entries(res.data.displayList)) {
              list[value['typeCode']] = value['typeName']
            }
            for (const [key, value] of entries(list)) {
              listArr.push({
                code: key,
                name: value
              })
            }
            listArr.push({ code: '-1', name: '其他' })
          }
        }
      )

      this.clientTypes = listArr
      this.curParams.clientType.push(this.detailData.thirdType.toString())
    },
    typeClickHandle (type) {
      this.curParams.clientType = []
      this.curParams.clientType.push(type)
      // if(this.curParams.clientType.includes(type)){
      //     // this.curParams.clientType.splice(this.curParams.clientType.indexOf(type),1)
      // }else{
      //     this.curParams.clientType.push(type)
      // }
    },
    // 处理原始文件函数
    processFile (file, next) {
      console.log('............')
      console.log('file1:', file.base64) // 原图片
      compress(file, {
        compress: {
          width: 1600,
          height: 1600,
          quality: 0.2
        }
      }, (file) => {
        console.log('file2:', file.base64) // 压缩后的图片
        console.log(this.files)
        next(file)
      })
    },
    filesAdded (files) {
      let hasIgnore = false
      // 最大5M
      const maxSize = 5 * 1024 * 1024// 最大上传范围

      for (let i = 0; i < files.length; i++) {
        const file = files[i]
        // 如果选择的图片大小最大限制（这里为5M）则弹出提示
        if (file.size > maxSize) {
          file.ignore = true
          hasIgnore = true
          break
        }
      }
      hasIgnore && this.$createToast({
        type: 'warn',
        time: 800,
        txt: '上传图片过大'
      }).show()
    },
    // 压缩图片方法
    compressPic (bdata) {
      // 注意这里this作用域的问题
      //  let that = this;
      // // 这里quality的范围是（0-1）
      // var quality = 0.1;
      // for( var i = 0;i<bdata.length;i++){
      //     var canvas = document.createElement("canvas");
      //     var ctx = canvas.getContext("2d");
      //     var img = new Image();
      //     img.src = bdata[i];
      //     img.onload =function() {
      //         var width = img.width;
      //         canvas.width = width;
      //         canvas.height = width * (img.height / img.width);
      //         ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
      //         let data = canvas.toDataURL("image/png",quality);
      //         that.model.photoes.push(data)
      //     }
      // }
      // setTimeout(function(){
      //     addFeedBack(that.model).then(res=>{
      //         if(res.code === 1){
      //             that.addsubmit = false
      //            that.toastsub.hide()
      //             that.$router.push({name:"feedbackSuccess"})
      //         }else{
      //             that.toastsub.hide()
      //         }

      //     })
      // },1200)
      const that = this
      that.model.photoes = bdata
      addFeedBack(that.model).then(res => {
        if (res.code === 1) {
          that.addsubmit = false
          that.toastsub.hide()
          that.$router.push({ name: 'feedbackSuccess' })
        } else {
          that.toastsub.hide()
          // this.$router.push({name:'addDetail',query:{data:JSON.stringify(this.detailData),frash:true}})
        }
      })
    },
    submitHandler (e) {
      console.log('...')
      console.log(this.imgList)
      // this.pushUserLog('提交反馈')
      this.addsubmit = true
      e.preventDefault()
      this.model.photoes = []
      this.photoes = []
      // for(var i = 0;i<this.imgObject.length;i++){
      //     // this.compressPic(this.imgList[i])
      //     this.photoes.push(this.imgObject[i].base)
      // }
      for (var i = 0; i < this.files.length; i++) {
        // this.compressPic(this.imgList[i])
        this.photoes.push(this.files[i].base64)
      }

      for (let i = 0; i < this.clientTypes.length; i++) {
        if (this.curParams.clientType[0] === -1) {
          this.model.clientType = this.model.clientTypeName
          break
        }
        if (this.curParams.clientType[0] === this.clientTypes[i].code) {
          this.model.clientType = this.clientTypes[i].name
        }
      }
      // this.model.photoes  =this.imgList
      this.toastsub = this.$createToast({
        txt: '正在提交。。。',
        time: 0,
        mask: false
      }).show()
      this.compressPic(this.photoes)
    },
    validateHandler (result) {
      this.validity = result.validity
      this.valid = result.valid
      console.log('validity', result.validity, result.valid, result.dirty, result.firstInvalidFieldIndex)
    },
    resetHandler (e) {
      console.log('reset', e)
    }

  }
}
</script>

<style lang="stylus" scoped>
    @import "../../stylus/base/base.styl"
    .feedbackBox{
        height 100%
        .closeBox{
            padding 32px
            padding-top 100px
            .formBox{
                li{

                    .title{
                        display flex
                        align-items  center
                        padding 20px 0
                        img{
                            width 30px
                            height 30px
                        }
                        .title-p{
                            font-size 28px
                            margin-left 30px
                            color #333333
                        }
                    }

                }
            }
        }
        .imgShow{
            color #999999
            font-size 24px
            line-height 30px
            padding-left 60px
        }
        .clientBox{
            overflow hidden
            padding-left 60px
            button{
                padding 8px 20px
                margin-right 75px
                margin-bottom 20px
                border 1px solid $color-font-lighter
                font-size $font-M
                color $color-font-lighter
                margin-right 30px
                border-radius 30px
                &.selected{
                    background $color-main
                    border-color $color-main
                    color #FFF
                    border-raidus 30px
                }
                &:last-child{
                    margin-right 0
                }
            }
        }
        .cube-btn{
            background #5785ea
            border-radius 40px
            margin-top 30px
        }
        .cube-input{
            border-bottom 1px solid #999
        }
        .line{
            height 1px
            margin-left 20px
            background #999
        }
        .cube-form-item{
            padding-left:60px
        }

    }
</style>
